// <div class="form-group" data-controller='select2'>
//   <%= f.select :user_id, User.all.map { |user| user.name }, {include_blank: false, required: true, include_hidden: false}, class: 'form-control content-search' %>
// </div>

import { Controller } from "@hotwired/stimulus"
import Choices from "choices.js"
import { debounce } from "$js/utilities/debounce"

export default class extends Controller {

  initialize() {
    this.search = debounce(this.search.bind(this), 250);
  }

  async connect() {
    // Initialize all select elements within rov-select2-wrapper
    const selectElements = document.querySelectorAll('.rov-select2-wrapper select');
    selectElements.forEach(select => {
      const choice = new Choices(select);

      const ajaxURL = this.data.get("ajax-url");
      if (ajaxURL) {
        this.ajaxifyChoice(choice, select, ajaxURL);
      }
    });
  }

  ajaxifyChoice(choice, element, ajaxURL) {
    element.addEventListener('search', async (e) => {
      let searchTerm = e.detail.value;
      if (searchTerm.length < 3) { return; }

      this.search(ajaxURL, searchTerm, (results) => {
        choice.setChoices(results, 'value', 'label', true);
      });
    });
  }

  async search(ajaxURL, term, callback) {
    let data = await fetch(ajaxURL + `?q=${term}`);
    let json = await data.json();
    let shapedData = json.map(item => ({ label: item.display_name, value: item.id }));
    callback(shapedData);
  }
}
